export default "__VITE_ASSET__jIvsxf7E__"